import { initFlashCounter } from 'components/flash/lib'
;($ => {
  $.petrescue = $.petrescue || {}

  $.petrescue.flash = (type, message) => {
    const $container = $('<div>', {
      class: 'c-flash js-c-flash component',
    })
    let $flash

    $container.appendTo($('#site-wrapper'))

    $flash = $('<div>', {
      class: type,
    }).append(
      $('<p>', {
        class: 'c-flash__message',
        text: message,
      })
    )

    if (type == 'notice') {
      const $counterElement = $('<div>', {
        class: 'c-flash__countdown js-c-flash__countdown js-c-flash__close',
        html: 'Closing message in <span class="js-c-flash__countdown__counter">5</span><i class="fa fa-times"></i>',
        data: { counter: 5 },
      })

      $flash.append($counterElement)
      initFlashCounter($counterElement)
    }

    if (type == 'alert') {
      $flash.append(
        $('<div>', {
          class: 'c-flash__close js-c-flash__close',
          html: 'Got it! Close this.',
        })
      )
    }

    $flash.appendTo($container)
  }
})(jQuery)
